import { render } from "./AlbumsBody.vue?vue&type=template&id=a9bfb964&scoped=true"
import script from "./AlbumsBody.js?vue&type=script&lang=js"
export * from "./AlbumsBody.js?vue&type=script&lang=js"

import "./AlbumsBody.css?vue&type=style&index=0&id=a9bfb964&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9bfb964"]])

export default __exports__